/* Quick-shop modal - reassurance strip.

   The modal is the last thing a shopper sees before adding to cart from a
   collection page, and it carried none of the shipping or returns copy the
   product page does. This injects the same three facts under the buy buttons.

   Why JavaScript rather than a theme block: the modal is rendered by Horizon's
   quick-add component from a fetched product fragment, and there is no block
   slot in it to target from the theme editor. It is also re-rendered from
   scratch every time a different card is opened, so a one-shot injection at
   page load would only ever apply to the first product.

   Hence the MutationObserver: it watches for the modal's content being swapped
   and re-inserts the strip, guarding on a data flag so repeated mutations
   during a single open do not stack copies of it.

   The three claims are the ones on the policies page and the homepage trust
   row, deliberately kept identical so the site never states two versions of
   the same promise. Returns wording updated 31 Aug 2026 when XSREZ started
   sending a free prepaid label - see claude/xsrez-claims-and-policy.md, which
   lists this file among the places that copy lives. Returns rewritten again
   16 Oct 2026: the window is now 7 days and a 20% restocking fee applies, so
   the word "free" had to go. XSREZ still buys the label, which is the part
   worth saying here. The fee is named only on the FAQ, the Policies page and
   the legal Refund policy - never on a product surface. Shipping wording updated
   14 Sep 2026: the offer is free STANDARD shipping, because the automatic
   discount now carries a maximumShippingPrice of $16.00 and expedited service
   is charged at the carrier rate. Do not drop the word "standard".

   Note on what is NOT shown: Horizon renders a `.ships-from-estimate` element
   in this modal carrying "Est. 3 day shipping from $11.00", which the theme
   then hides with display:none. It stays hidden. That figure is a
   carrier-rate estimate that varies by destination, and surfacing "from
   $11.00" next to a $19.99 sock would do more harm than the reassurance is
   worth. "Officially licensed" is also absent on purpose - it is true of the
   team and fandom catalogue but not of the GRIP6 and Dango everyday-carry
   lines, and this strip renders for every product.
*/

(function () {
  var ICONS = {
    truck:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3V6Zm12 3h3.4l2.6 3.2V15h-6V9ZM6.5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>',
    clock:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 10.6 4 2.3-1 1.7-5-2.9V6h2v6.6Z"/></svg>',
    ret:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4V1L8 5l4 4V6a6 6 0 1 1-6 6H4a8 8 0 1 0 8-8Z"/></svg>'
  };

  var ITEMS = [
    [ICONS.truck, 'Free standard U.S. shipping over $75 (fine jewelry $150)'],
    [ICONS.clock, 'Ships in 1-3 business days'],
    [ICONS.ret, '7-day returns, we send the label']
  ];

  // Fine jewelry (Stuller) is finished to order and its ship time is not
  // known, so the "Ships in 1-3 business days" line is dropped for it.
  // The hidden .ships-from-estimate in the modal carries data-fine-vendor.
  function isFine(modal) {
    var est = modal.querySelector('.ships-from-estimate');
    return !!(est && est.dataset.fineVendor);
  }

  function build(fine) {
    var ul = document.createElement('ul');
    ul.className = 'xs-qs-trust';
    ul.setAttribute('role', 'list');
    ul.dataset.fine = fine ? '1' : '0';
    var items = fine ? ITEMS.filter(function (it) { return it[0] !== ICONS.clock; }) : ITEMS;
    ul.innerHTML = items.map(function (it) {
      return '<li>' + it[0] + '<span>' + it[1] + '</span></li>';
    }).join('');
    return ul;
  }

  function inject() {
    var modal = document.querySelector('.quick-add-modal');
    if (!modal) return;
    var details = modal.querySelector('.product-details');
    if (!details) return;
    var fine = isFine(modal);
    var existing = details.querySelector('.xs-qs-trust');
    if (existing) {
      if (existing.dataset.fine === (fine ? '1' : '0')) return;
      existing.remove();
    }
    details.appendChild(build(fine));
  }

  function start() {
    inject();
    var root = document.body;
    if (!root) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      // Coalesce: the component swaps a whole subtree, which fires many records.
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        inject();
      }, 60);
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
